import { useEffect, useState } from "react";
import { Loader2, FileText } from "lucide-react";
import { Progress } from "@/components/ui/progress";

export const ProgressCard = ({ job, uploadPct, fileName, startedAt, offline }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const uploading = !job;
  const total = job?.total || 0;
  const done = job?.done || 0;
  const pct = uploading ? uploadPct : total ? Math.round((done / total) * 100) : 3;
  const secs = Math.max(0, Math.floor((now - startedAt) / 1000));
  const elapsed = secs >= 60 ? `${Math.floor(secs / 60)}m ${secs % 60}s` : `${secs}s`;
  const remaining = !uploading && done > 2 && total > done ? Math.round(((now - startedAt) / 1000 / done) * (total - done) / 60) : null;
  const label = uploading ? `Caricamento file: ${uploadPct}%` : job?.queued ? "In coda: il server sta finendo un'altra conversione…" : total ? `Pagine lette: ${done} di ${total}` : "Preparazione pagine…";

  return (
    <section data-testid="ocr-progress-card" className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-10 fade-up">
      <div className="flex items-center gap-3 text-slate-500 text-sm">
        <FileText className="w-4 h-4" />
        <span data-testid="progress-file-name" className="truncate">{fileName}</span>
        {job?.file_count > 1 && <span data-testid="progress-current-file" className="truncate text-slate-400">· ora: {job.current_file}</span>}
      </div>
      <div className="mt-6 flex items-center gap-3">
        <Loader2 className="w-6 h-6 animate-spin text-emerald-600" />
        <h2 className="font-display text-xl sm:text-2xl font-bold text-slate-900">{uploading ? "Caricamento in corso…" : "Conversione OCR in corso…"}</h2>
      </div>
      <Progress data-testid="ocr-progress-bar" value={pct} className="mt-8 h-2 bg-slate-100" />
      <div className="mt-4 flex justify-between text-sm font-mono text-slate-600">
        <span data-testid="progress-pages">{label}</span>
        <span data-testid="progress-elapsed">{elapsed}{remaining !== null && ` · mancano circa ${Math.max(1, remaining)} min`}</span>
      </div>
      {offline && (
        <p data-testid="progress-offline" className="mt-4 rounded-lg bg-amber-50 px-3 py-2 text-xs text-amber-800">
          Connessione instabile: riprovo in automatico, la conversione continua sul server.
        </p>
      )}
      {job?.resumes > 0 && (
        <p data-testid="progress-resumed" className="mt-4 rounded-lg bg-sky-50 px-3 py-2 text-xs text-sky-800">
          Il server si è riavviato: la conversione è ripresa da sola. I file già letti sono salvati; quello in corso viene riletto dall'inizio.
        </p>
      )}
      <p className="mt-6 text-xs text-slate-400">
        {uploading ? "Non chiudere la pagina durante il caricamento." : "La conversione continua sul server: puoi ricaricare questa pagina o tornarci con lo stesso indirizzo."}
      </p>
    </section>
  );
};
